import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import { loc } from '../../lib/loc';
import { RegisterLoc } from '../../loc/register';

import PreloadButton from '../../interface/PreloadButton';
import { useStores } from '../../hooks/use-stores';
import InputWithCountrySelect from '../UI/InputWithCountrySelect';
import ErrorMessage from '../../interface/ErrorMessage';

const ExistingLegalRegisterForm = observer(() => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const { RegisterStore: store } = useStores();
    const { loaderSearch, company, errorMessage, registerLegalExisting } = store || {};

    const register = e => registerLegalExisting(e, phoneNumber);

    return (
        <form onSubmit={register}>
            {errorMessage && <ErrorMessage message={errorMessage} />}
            <input
                className="legal-form__input"
                style={{ width: '100%' }}
                name="contact_name"
                placeholder={loc(RegisterLoc.form.contactName)}
                required
            />
            <InputWithCountrySelect setPhone={setPhoneNumber} placeholder={loc(RegisterLoc.form.phoneNumber)} />

            <input
                className="legal-form__input"
                style={{ width: '100%' }}
                name="contact_email"
                placeholder={loc(RegisterLoc.form.email)}
                required
            />
            <div>
                <p>{company.name}</p>
                <Link to="/login/">{loc(RegisterLoc.not_your_company)}</Link>
            </div>
            <div className="legal-form__wrap-btn">
                <PreloadButton className="legal-form__btn" isLoad={loaderSearch}>
                    {loc(RegisterLoc.buttonAccept)}
                </PreloadButton>
            </div>
        </form>
    );
});

export default ExistingLegalRegisterForm;
